export const LOGIN = "login";
export const SIGNUP = "signup";
export const PUBLIC = "public";
export const RESET_PASSWORD = "resetPassword";
